var routes = require('next-routes')();

routes.add('main', '/:videoId');
export default routes;